
import Utils from '~/assets/utils.js'
import Head from '~/assets/head.js'

export default {
  mixins: [Head.titleMixin],
  async asyncData ({ $content }) {
    let allPosts = await $content('posts', { deep: true })
      .only(['post_title', 'dir', 'slug', 'date', 'unlisted_post', 'hero', 'path', 'project_desc', 'excerpt_desc', 'tags'])
      .fetch()

    allPosts.map((post) => {
      if (!post.date) {
        post.date = new Date(0)
      }
      post.color = Utils.getRandColor()
      return post
    })

    allPosts = allPosts.filter(post => !post.unlisted_post && post.post_title)
    allPosts.sort((a, b) => (a.date <= b.date ? 1 : -1))

    const tagSet = new Set()
    for (const post of allPosts) {
      if (!post.tags) { continue }

      for (const tag of post.tags) {
        // Make the first letter of each word an upper case character
        tagSet.add(tag.toLowerCase())
      }
    }

    const tags = Array.from(tagSet).map(tag => tag.replace(/(^\w{1})|(\s+\w{1})/g, letter => letter.toUpperCase()))

    return {
      tags: Array.from(tags),
      tagSet,
      posts: allPosts,
      searchedArticles: allPosts,
      title: 'My Posts',
      description: 'All of my posts in one place.'
    }
  },
  data () {
    return {
      selectedTags: [],
      searchQuery: '',
      searchedArticles: []
    }
  },
  watch: {
    '$route.query' (q) {
      // this.$router.go()
    },
    async searchQuery (searchQuery) {
      return await this.filterByQuery(searchQuery)
    },
    async selectedTags (tags) {
      if (!tags.length) {
        return await this.filterByQuery(this.searchQuery)
      }

      this.filterByTags(tags)
    }
  },
  methods: {
    // Random color generation from here: http://blog.adamcole.ca/2011/11/simple-javascript-rainbow-color.html
    getRandColor () {
      return Utils.getRandColor()
    },
    prettifyDate (date) {
      return Utils.prettifyDate(date)
    },
    setFilter (filter) {
      this.selectedFilter = filter
      // this.$router.push({
      //   path: this.$route.path,
      //   query: {
      //     t: this.selectedFilter
      //   }
      // })
      // this.$router.push(`${this.$route.path}?t=${filter}`)
      // this.$router.replace({ query: { 'filter': filter }})
    },
    removeActiveTag (tag) {
      this.selectedTags.splice(this.selectedTags.indexOf(tag), 1)
      this.filterByTags(this.selectedTags)
    },
    async filterByQuery (searchQuery) {
      this.searchedArticles = await Utils.searchArticlesByQuery(searchQuery, this.$content, ['post_title', 'project_desc', 'excerpt_desc'], 'posts', this.posts)
    },
    filterByTags (tags) {
      this.tagSet = new Set(tags.map(tag => tag.toLowerCase()))
      // console.log(this.tagSet)

      this.searchedArticles = this.posts.filter((post) => {
        if (!post.tags) { return false }
        let numTagsFound = 0
        for (const tag of post.tags) {
          if (this.tagSet.has(tag.toLowerCase())) { numTagsFound += 1 }
        }
        // console.log(numTagsFound)
        // console.log(this.tagSet.size)
        if (numTagsFound === this.tagSet.size) { return true }
        return false
      })
      // console.log(this.searchedArticles)
    }
  }
}
